export default __webpack_public_path__ + "static/media/include_14_female@3x.cf388f87.jpg";